import { useState } from 'react';
import { useRouter } from 'next/router';
import { getContainer } from '@framework/di/getContainer';
import { useDocumentGroupContext } from '@/creditflowresearch/application/Research/DocumentGroupContext';
import DocumentGroup from '@/creditflowresearch/domain/DocumentGroup';
import { IResearchPayloadOverrides } from '@/creditflowresearch/domain/vo/research/IResearchResponse';
import URL from '@/creditflowresearch/Router/urlConstants';

export const useResearchDocumentGroup = (
  searchFieldValue: string | string[],
  paginate: (page: number, payload?: IResearchPayloadOverrides) => Promise<void>,
) => {
  const container = getContainer();
  const router = useRouter();
  const documentGroupService = container.get(DocumentGroup);
  const { pathname, asPath } = router;

  const {
    collection: documentGroupsCollection,
    documentGroup: documentGroupsItem,
    setDocumentGroup,
  } = useDocumentGroupContext();

  const [isChangingDocumentGroup, setIsChangingDocumentGroup] = useState(false);

  const documentGroupChanged = async (documentGroup) => {
    const document = documentGroupService.getByGroupName(documentGroupsCollection, documentGroup);
    if (documentGroupsItem?.groupName !== documentGroup) {
      setIsChangingDocumentGroup(true);
      setDocumentGroup(document);

      const payload: IResearchPayloadOverrides = {
        page: 1,
        search: searchFieldValue,
        filter: { includedDocumentGroupId: document.groupId },
      };

      try {
        await paginate(1, payload);

        if (pathname.includes(URL.NRSRO_RESEARCH)) {
          const searchParams = asPath.includes('?') ? asPath.substring(asPath.indexOf('?')) : '';
          await router.replace(
            `${ URL.NRSRO_RESEARCH }/${ documentGroup.toLocaleLowerCase() }${ searchParams }`,
            undefined,
            { shallow: true },
          );
        }
      } finally {
        setIsChangingDocumentGroup(false);
      }
    }
  };

  return {
    documentGroupChanged,
    isChangingDocumentGroup,
  };
};
